const OFFSET_SUFFIX = /(Z|[+-]\d{2}:\d{2})$/i;
const DAY_MS = 24 * 60 * 60 * 1000;

export function parseVirtualExpiry(value) {
  if (!value) return null;
  const text = String(value).trim();
  const normalized = OFFSET_SUFFIX.test(text) ? text : `${text}+08:00`;
  const timestamp = Date.parse(normalized);
  return Number.isFinite(timestamp) ? timestamp : null;
}

export function isVirtualExpired(product, now = Date.now()) {
  if (product?.expired) return true;
  const expiry = parseVirtualExpiry(product?.unpublishAt);
  return expiry != null && expiry <= now;
}

export function formatVirtualCountdown(unpublishAt, now = Date.now()) {
  const expiry = parseVirtualExpiry(unpublishAt);
  if (expiry == null) return null;

  const remaining = expiry - now;
  if (remaining <= 0) return 'SOLD OUT · 登記已截止';

  if (remaining > 7 * DAY_MS) {
    const deadline = new Intl.DateTimeFormat('zh-TW', {
      timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    }).format(new Date(expiry));
    return `登記截止：${deadline}`;
  }

  if (remaining > DAY_MS) {
    const days = Math.floor(remaining / DAY_MS);
    const hours = Math.floor((remaining % DAY_MS) / (60 * 60 * 1000));
    return `剩餘 ${days} 天 ${hours} 小時`;
  }

  const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `剩餘 ${hours}:${minutes}:${seconds}`;
}
